import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight } from '@fortawesome/free-solid-svg-icons'

import './CTAButton.css'

export default function CTAButton(props) {
    const lightclass = (props.lightcta != true) ? '' : 'lightcta'
    const className = ('ctabutton noselect ' + (props.className || '') + ' ' + lightclass).replace(/\s+/g, ' ').trim()

    const icon =
        props.showArrow == true
            ? <FontAwesomeIcon className="ctaiconright" icon={faArrowRight} />
            : (props.customIcon)
                ? <FontAwesomeIcon className={props.iconLeft == true ? "ctaiconleft" : "ctaiconright"} icon={props.customIcon} />
                : null

    const label = <span className="ctabutton_label">{props.title}</span>

    const content = (
        <span className="ctabutton_content">
            {props.iconLeft != true ? label : null}
            {icon}
            {props.iconLeft == true ? label : null}
        </span>
    )

    const handleClick = (typeof props.onclick === 'function') ? () => props.onclick() : undefined

    // Mit href: echter, crawlbarer Link (beschreibender Text = title).
    // Ohne href: Aktion -> semantischer Button (kein href="#", das von Lighthouse als nicht crawlbar bemängelt wird).
    if (props.href) {
        return (
            <a
                href={props.href}
                className={className}
                onClick={handleClick}
                {...(props.download ? { download: props.download === true ? true : props.download } : {})}
            >
                {content}
            </a>
        )
    }

    return (
        <button type="button" className={className} onClick={handleClick}>
            {content}
        </button>
    )
}
